import { Box, FlexGrid } from '@telus-uds/components-web'
import { node } from 'prop-types'

const OfferDetailsContainer = ({ children }) => (
  <FlexGrid gutter={false} testID="OfferDetail-container">
    <FlexGrid.Row>
      <FlexGrid.Col xs={12} lg={10} lgOffset={2}>
        <Box>{children}</Box>
      </FlexGrid.Col>
    </FlexGrid.Row>
  </FlexGrid>
)

OfferDetailsContainer.propTypes = {
  children: node.isRequired
}

export default OfferDetailsContainer
